import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  currencies: [],
};

const currency = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default currency;
